import React from 'react';
import PropTypes from 'prop-types';
import * as types from '../../../constants/actionTypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as statusActions } from '../../../actions/statusActions';
import { actions as coreStatusActions } from '../../../actions/coreStatusActions';
import StatusForm from '../Identifiers/taskStatusForm';
import { DEFAULT_PAGE_SIZE } from '../../../constants/constants';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import Drawer from '../../Common/Drawer/Drawer';
import Icon from '../../Common/Icon';
import Notification from '../../../components/Common/Notification';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import { getDataTableSortFields, getSearchParamSortFields } from '../../../helpers/sortHelper';
import { getNullableOnChangeValue } from '../../../helpers/multiselect';

export class Status extends React.Component {

    constructor(props, context) {
        super(props, context);

        const newStatus = {
            id: 0,
            name: "",
            isActive: true,
            defaultNotStarted: false,
            subscriptionId: props.subscriptionId,
            coreStatusId: ""
        };

        this.state = {
            statuses: [],
            coreStatuses: [],
            totalCount: 0,
            isFetching: false,
            isSaving: false,
            selectedStatus: newStatus,
            editStatus: newStatus,
            selectedStatusId: 0,
            newStatus: newStatus,
            drawerOpen: false,
            isFormValid: true,
            showInactiveWarning: false,
            showDefaultWarning: false,
            searchParams: {
                subscriptionId: props.subscriptionId,
                isActive: true,
                pageSize: DEFAULT_PAGE_SIZE,
                pageNumber: 1,
                sortBy: "name",
                sortDir: "asc",
                name: "",
                coreStatusId: 0
            }
        };
        this.search.bind(this);
    }

    async componentDidMount() {
        await this.search();
        await this.loadCoreStatuses();
    }

    async search() {
        try {
            this.setState({ isFetching: true });
            const result = await this.props.actions.status.searchStatuses(this.state.searchParams);
            const payload = result.payload;
            if (result.type === types.SEARCH_STATUS_SUCCESS) {
                this.setState({ statuses: payload.results, totalCount: payload.totalCount });
            } else if (result.type === types.SEARCH_STATUS_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isFetching: false });
        }
    }

    async loadCoreStatuses() {
        try {
            const result = await this.props.actions.coreStatus.loadCoreStatuses();
            const payload = result.payload;
            if (result.type === types.LIST_CORESTATUS_SUCCESS) {
                this.setState({ coreStatuses: payload.coreStatuses });
            } else if (result.type === types.LIST_CORESTATUS_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        }
    }

    async save() {
        try {
            this.setState({ isSaving: true });
            const result = await this.props.actions.status.saveStatus(this.state.editStatus)

            if (result.type === types.CREATE_STATUS_SUCCESS || result.type === types.UPDATE_STATUS_SUCCESS) {
                Notification("success", "Save Successful", "Status saved successfully")
                this.setState({ drawerOpen: false });
                this.setState({ searchParams: { ...this.state.searchParams, pageNumber: 1 } }, () => {
                    this.search();
                });
            } else if (result.type === types.UPDATE_STATUS_FAILURE || result.type === types.CREATE_STATUS_FAILURE) {
                this.setState({ errorMessage: result.payload.message });
                Notification("error", "An Error Occurred", result.payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isSaving: false });
        }

    }

    filterByCoreStatus = (e) => {
        this.setState({ searchParams: { ...this.state.searchParams, coreStatusId: e.value } }, () => {
            this.search();
        });
    }

    filterNameChange = (e) => {
        this.setState({ searchParams: { ...this.state.searchParams, name: e.target.value } });
    }

    keyUpName = (e) => {
        if (e.keyCode == 13) {
            this.search();
        }
    }

    onSearchBlur = () => {
        this.search();
    }

    onActiveChange = (e) => {
        const selectedValue = getNullableOnChangeValue(e);
        
        this.setState({ searchParams: { ...this.state.searchParams, isActive: selectedValue } }, () => {
            this.search();
        });
    }

    onAddNew = () => {
        this.setState({ selectedStatus: null, editStatus: this.state.newStatus, drawerOpen: true, errorMessage: "", isFormValid: true, showDefaultWarning: false, showInactiveWarning: false });
    }

    onFormChange = (name, value) => {
        if (name == "defaultNotStarted" && value == false && this.state.editStatus.id != 0) {
            this.setState({ showDefaultWarning: true });
        } else if (name == "isActive" && this.state.editStatus.defaultNotStarted == true) {
            this.setState({ showInactiveWarning: true });
        } else {
            this.setState({ editStatus: { ...this.state.editStatus, [name]: value } });
        }
    }

    saveClick = () => {

        if (this.state.editStatus.name.trim().length < 1) {
            this.setState({ isFormValid: false });
            return;
        }

        if (this.state.editStatus.coreStatusId == '') {
            this.setState({ isFormValid: false });
            return;
        }

        this.setState({ isFormValid: true });
        this.save();
    }

    cancelClick = () => {
        this.setState({ drawerOpen: false });
    }

    selectStatus = (e) => {
        const newValue = e.value || this.state.selectedStatus;
        this.setState({ selectedStatus: newValue, editStatus: newValue, drawerOpen: true, isFormValid: true, showInactiveWarning: false, showDefaultWarning: false });
    }

    activeTemplate = (rowData) => {
        if (rowData.isActive) {
            return <div className="text-success text-center"><Icon name="check-circle" /></div>;
        } else {
            return <div className="text-danger text-center"><Icon name="times-circle" /></div>;
        }
    }

    coreStatusOptions = () => {
        let options = [
            { label: "All", value: 0 }
        ];

        for (let i = 0; i < this.state.coreStatuses.length; i++) {
            options.push({ label: this.state.coreStatuses[i].name, value: this.state.coreStatuses[i].id });
        }
        return options;
    }

    onSort = ({ sortField, sortOrder }) => {
        const { sortBy, sortDir } = getSearchParamSortFields(sortField, sortOrder);
        if (sortBy !== this.state.searchParams.sortBy || sortDir !== this.state.searchParams.sortDir) {
            this.setState({
                searchParams: {
                    ...this.state.searchParams,
                    sortBy: sortBy,
                    sortDir: sortDir
                }
            }, this.search);
        }
    }

    onPageChange = (e) => {
        this.setState({ searchParams: { ...this.state.searchParams, pageNumber: (e.page + 1) } }, () => {
            this.search();
        });
    }

    render() {

        const activeOptions = [
            { label: "Yes", value: true },
            { label: "No", value: false },
            { label: "All", value: null }
        ];
        
        const activeFilter = (
                            <Dropdown
                                className="ui-column-filter"
                                value={this.state.searchParams.isActive}
                                options={activeOptions}
                                optionLabel="label"
                                optionValue="value"
                                onChange={this.onActiveChange}
                                placeholder="Select an option"
                            />
                        );

        const nameFilterElement =
            <input type="text" className="p-inputtext" placeholder="Filter by Name" size="50" onBlur={this.onSearchBlur} onChange={this.filterNameChange} onKeyUp={this.keyUpName} value={this.state.searchParams.name} />
        ;

        const coreStatusFilter = <Dropdown className="ui-column-filter" style={{ width: '100%' }} value={this.state.searchParams.coreStatusId} options={this.coreStatusOptions()} onChange={this.filterByCoreStatus} />
        const { sortField, sortOrder } = getDataTableSortFields(this.state.searchParams);

        return (
            <div>
                {this.state.drawerOpen ?
                    <Drawer isWide={false} title="Status" onSaveClick={this.saveClick} onCancelClick={this.cancelClick}>
                        <StatusForm
                            coreStatuses={this.state.coreStatuses}
                            onFormChange={this.onFormChange}
                            isFormValid={this.state.isFormValid}
                            onSubmit={this.saveClick}
                            status={this.state.editStatus}
                            showInactiveWarning={this.state.showInactiveWarning}
                            showDefaultWarning={this.state.showDefaultWarning}
                        />
                    </Drawer>                
                :
                ""
                }

                <LoadingIndicator isLoading={this.state.isFetching || this.state.isSaving} hideWhileLoading={true}>
                    <div>
                        <div className="identifier-header">
                            <div className="title">Status</div>
                            <div className="close">
                                <button type="button" onClick={this.props.onClose} alt="close popup"><Icon name="times" /></button>
                            </div>
                        </div>

                        <div className="identifier-add-new">
                            <div className="col-sm-12">
                                <button type="button" className="btn btn-primary" onClick={this.onAddNew} alt="close popup"><span className="me-2">Add New</span><Icon name="plus-circle" /></button>
                            </div>
                        </div>

                        <div className="identifier-results-table">
                            <DataTable
                                filterDisplay="row"
                                className="p-datatable-sm p-datatable-striped"
                                value={this.state.statuses}
                                selectionMode="single"
                                selection={this.state.selectedStatus}
                                onSelectionChange={this.selectStatus}
                                sortField={sortField}
                                sortOrder={sortOrder}
                                onSort={this.onSort}
                                >
                                <Column field="name" header="Name" sortable={true} filter={true} filterElement={nameFilterElement} />
                                <Column field="coreStatusName" header="Core Status" sortable={true} filter={true} filterElement={coreStatusFilter} />
                                <Column field="isActive" header="Active" sortable={true} body={this.activeTemplate} style={{ width: '120px' }} filter={true} filterElement={activeFilter} />
                            </DataTable>
                            {
                                this.state.totalCount > this.state.searchParams.pageSize &&
                                <Paginator
                                    rows={this.state.searchParams.pageSize}
                                    totalRecords={this.state.totalCount}
                                    first={(this.state.searchParams.pageNumber - 1) * this.state.searchParams.pageSize}
                                    onPageChange={this.onPageChange} />
                            }
                            <div className="results-count">Total records: {this.state.totalCount}</div>
                        </div>
                    </div>
                </LoadingIndicator>
            </div>
        );
    }

}

Status.propTypes = {
    subscriptionId: PropTypes.number.isRequired,
    actions: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            status: bindActionCreators(statusActions, dispatch),
            coreStatus: bindActionCreators(coreStatusActions, dispatch)
        }
    };
}

export default connect(null, mapDispatchToProps)(Status);

